import React from 'react';
import { useNavigate } from 'react-router-dom';

import Icone from 'Component/Icone';
import { useAppSelector } from 'Store';
import { useRecuperarEmprestimosEpiQuery } from 'View/Service/Default/EmprestimosEpi';

const EmprestimosEpi = (): React.ReactElement => {
  const navegacao = useNavigate();

  const usuario = useAppSelector((estado) => estado.autenticacao.usuario);

  const { data: { emprestimos } = {} } = useRecuperarEmprestimosEpiQuery({
    options: { usuario_id: usuario?.id, assinado: 0 },
  });

  return (
    <React.Fragment>
      {emprestimos?.length ? (
        <div
          className="alert alert-danger cursor-pointer"
          onClick={() => navegacao('/emprestimos-epi/historico')}
        >
          <strong className="me-3">
            <Icone nome="exclamation-circle-fill" /> Atenção
          </strong>
          Existem emprestimos de EPIs em aberto para você assinar!
        </div>
      ) : null}
    </React.Fragment>
  );
};

export default EmprestimosEpi;
